@if (view.site && view.site.profile && view.site.profile.pages) {
    @switch (view.site.profile.pages.corporateTravel) {
        @case (1) {
            <app-corporate-travel-type01></app-corporate-travel-type01>
            }
        @case (2) {
            <app-corporate-travel-type02></app-corporate-travel-type02>
            }
    }
}
